export default "__VITE_ASSET__DA2k$udl__"